import type { StorageUsage } from '@moussenaires/shared';

import { api } from './client.js';

export const storageApi = {
  usage: () => api.get<StorageUsage>('/storage'),
};
